import { Button, Grid, TextField, Typography } from "@material-ui/core";
import DateComponent from "../../../../../../Components/FormGenerator/datepicker_component";
import { useEffect, useState } from "react";
import DataService from "../../../../../../Service";
import { useLocation } from "react-router";
import moment from "moment";
import AdminPartnerClient from "../../../../../../Service/Admin/partner_services";
import { ObjectToFormdata } from "../../../../../../Common/Utils/common_utils";

const InternalUseOnly = () => {
  const location = useLocation();
  const assignmentID = location?.state?.currentAssignment?.id;
  const [userData, setUserData] = useState({
    internal_note: "",
    coordinator_notes: "",
    extension_notes: "",
    coordinator_follow_up_date: "",
  });

  const handleChange = (key, value) => {
    setUserData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = () => {
    AdminPartnerClient.InternalUseOnly(
      { assignment_id: assignmentID },
      ObjectToFormdata(userData)
    ).then((response) => console.log("res", response));

    // DataService.getData(
    //   { assignment_id: assignmentID },
    //   "assignmentInternalDetails"
    // )
    //   .then((response) => {
    //     setUserData(response?.assignment_internal_detail);
    //   })
    //   .catch((error) => {});
  };

  const handleClear = () => {
    setUserData({
      internal_note: "",
      coordinator_notes: "",
      extension_notes: "",
      coordinator_follow_up_date: "",
    });

    DataService.getData(
      { assignment_id: assignmentID },
      "assignmentInternalDetails"
    )
      .then((response) => {
        setUserData(response?.assignment_internal_detail);
      })
      .catch((error) => {});
  }
  useEffect(() => {
    DataService.getData(
      { assignment_id: assignmentID },
      "assignmentInternalDetails"
    )
      .then((response) => {
        setUserData(response?.assignment_internal_detail);
      })
      .catch((error) => {});
  }, [assignmentID]);

  return (
    <div>
      <Grid>
        <Grid
          container
          direction='row'
          alignItems='center'
          style={{ padding: 30, marginBottom: 40 }}
        >
          <Grid item xs={10}>
            <Grid
              container
              direction='row'
              alignItems='center'
              style={{ marginBottom: 20 }}
            >
              <Grid item xs={4}>
                <Typography variant='h2'>Internal notes</Typography>
              </Grid>
              <Grid item xs={8}>
                <div>
                  <TextField
                    label='Internal notes'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    multiline
                    fullWidth
                    rows={4}
                    variant='outlined'
                    value={userData?.internal_note}
                    name='internal_note'
                    onChange={(event) =>
                      handleChange("internal_note", event.target.value)
                    }
                    inputProps={{ maxLength: 750 }} // Set the maximum length
                  />
                  {/* <p>
                    Characters remaining: {750 - userData?.internal_note?.length}
                  </p> */}
                </div>
              </Grid>
            </Grid>

            <Grid
              container
              direction='row'
              alignItems='center'
              style={{ marginBottom: 20 }}
            >
              <Grid item xs={4}>
                <Typography variant='h2'>Coordinator notes</Typography>
              </Grid>
              <Grid item xs={8}>
                <div>
                  <TextField
                    label='Coordinator notes'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    multiline
                    fullWidth
                    rows={4}
                    variant='outlined'
                    value={userData?.coordinator_notes}
                    name='coordinator_notes'
                    onChange={(event) =>
                      handleChange("coordinator_notes", event.target.value)
                    }
                    inputProps={{ maxLength: 750 }} // Set the maximum length
                  />
                  {/* <p>
                    Characters remaining:{" "}
                    {750 - userData?.coordinator_notes?.length}
                  </p> */}
                </div>
              </Grid>
            </Grid>
            <Grid container direction='row' alignItems='center'>
              <Grid item xs={4}>
                <Typography variant='h2'>
                  Coordinator follow up date{" "}
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <DateComponent
                  //   key={"001"}
                  name='coordinator_follow_up_date'
                  componentObject={{
                    componentType: "datePicker",
                    handleChange: (value) =>
                      handleChange("coordinator_follow_up_date", value),
                    value: moment(
                      userData?.coordinator_follow_up_date,
                      "DD/MM/YY"
                    ).format("DD/MM/YYYY"),
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction='row'
              alignItems='center'
              style={{ marginBottom: 20 }}
            >
              <Grid item xs={4}>
                <Typography variant='h2'>Extension notes</Typography>
              </Grid>
              <Grid item xs={8}>
                <div>
                  <TextField
                    label='Extension notes'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    multiline
                    fullWidth
                    rows={4}
                    variant='outlined'
                    value={userData?.extension_notes}
                    name='extension_notes'
                    onChange={(event) =>
                      handleChange("extension_notes", event.target.value)
                    }
                    inputProps={{ maxLength: 750 }} // Set the maximum length
                  />
                  {/* <p>
                    Characters remaining:{" "}
                    {750 - userData?.extension_notes?.length}
                  </p> */}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4} style={{ marginLeft: 676 }}>
            <Button
              disableElevation
              variant='contained'
              // disabled={loading}
              // onClick={() => handleEditLog(index)}
              onClick={handleClear}
            >
              Cancel
            </Button>
            <Button
              disableElevation
              // disabled={loading}
              variant='contained'
              color='secondary'
              // onClick={() => saveActivityDetails(true, index)}
              onClick={handleSubmit}
              style={{ marginLeft: 10 }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default InternalUseOnly;
